import ManageGroupsCtrl from '../groups/ManageGroupsCtrl.js';
import config from '../../../config';

import templateUrl from './positionsGroupComponent.html';

class PositionsGroupCtrl extends ManageGroupsCtrl {
  ARCHIVING_LOCATIONS_POSITIONS_ENABLED = config.ARCHIVING_LOCATIONS_POSITIONS_ENABLED;

  constructor(
    PersonaCollection,
    ConfirmService,
    Restangular,
    RestUtils,
    UserUtils,
    Authentication,
    AlertService,
    SalesService,
    $state,
    $parse,
    $document,
    $uibModal,
    filterFilter,
    uppercaseFirstFilter
  ) {
    'ngInject';

    super(
      PersonaCollection,
      ConfirmService,
      Restangular,
      RestUtils,
      Authentication,
      AlertService,
      $state,
      $parse,
      $uibModal,
      filterFilter,
      uppercaseFirstFilter
    );

    Object.assign(this, { SalesService, UserUtils });

    this.$document = $document;
    this.notAllowedTooltip = "You don't have permission to edit this position";
    this.emptyLabel = '-';
  }

  getPositionImportedTooltipMessage({ origin }) {
    if (!origin) {
      return '';
    }

    const capitalizedOrigin = origin.charAt(0).toUpperCase() + origin.slice(1);
    return `Positions imported from ${capitalizedOrigin} can't be deleted.`;
  }
}

export default {
  controller: PositionsGroupCtrl,
  controllerAs: 'ctrl',
  templateUrl,
  bindings: {
    hideHeader: '<?',
    displayMyGroups: '<?',
    columnSubset: '<?',
    search: '=?',
    selectedItemIds: '=',
    isSomethingSelected: '=',
    visibleItemsDict: '=',
    updateWage: '&',
    mergePosition: '&?',
    groupType: '@',
    cancelCounter: '<',
    saveCounter: '<',
  },
};
